export function calculateTotal(array, field, decimals) {
  const total = array.reduce((sum, item) => {

    const value = Number(item[field]) || 0;
    return sum + value;
  }, 0);

  return total.toFixed(decimals);
}

export function stringToRegex(regexString, flags = "") {
  try {
    // Remove leading/trailing slashes if present
    const pattern = regexString?.replace(/^\/|\/$/g, '');
    const correctedPattern = pattern?.replace(/(^|[^\\])d/g, '$1\\d');
    
    return new RegExp(correctedPattern, flags);
  } catch (e) {
    console.error("Invalid regex string:", regexString, e);
    return null;
  }
}

export function concatPhoneWithCountryCode(values, countryCode = '263') {
  // Create a copy of the object to avoid mutation
  const result = { ...values };

  // Only process if phone exists and is a string
  if (result.phone && typeof result.phone === 'string') {
    // Remove any existing country code, plus signs, or spaces
    const cleanPhone = result.phone.replace(/^\+?\d*\s*/, '').replace(/\D/g, '');
    
    // Ensure countryCode doesn't contain a plus sign or spaces
    const cleanCountryCode = countryCode.replace(/\D/g, '');
    
    // Concatenate without any separator
    result.phone = cleanCountryCode + cleanPhone;
  }

  return result;
}